<template>
  <div id="main-wrapper">
    <div v-if=" store.trans_id && store.trans_id_type == 'CHANGE PASSWORD'">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p>{{$t('account.we_have_received_your_request')}}</p>
              </div>
              <SuccessBox
                type="ipassword"
              />
              <!-- <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="resetAndBack">OK </a>
              </div> -->
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="resetAndBack">×</button>
            </div>
          </div>
        </div>
      </div>
    </div> 
    <div v-if="message">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-center">
                <p v-if="msgType == 'success'">{{$t('account.change_investor_password')}}</p>
                <p v-else>{{message}}</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="message = ''">{{$t('account.ok')}} </a>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="message = ''">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="content-container profile-page support-page add-label reset-pass"
    >
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder wow fadeInLeft">
              <h4>{{$t('account.reset_investor_password')}}</h4>
            </div>
            <div class="nav-holder clearfix wow fadeIn">
              <ul class="f-left">
                <li>
                  <router-link to="/reset-investor-pass" class="btn btn-yellow"
                    >{{$t('account.investor_password')}}</router-link
                  >
                </li>
                <li>
                  <router-link to="/reset-master-pass" class="btn btn-blue"
                    >{{$t('account.master_password')}}</router-link
                  >
                </li>
              </ul>
              <p class="f-right"><strong>{{$t('account.trading_iD')}}</strong>: {{form.account_id}}</p>
            </div>
            <div class="content-holder">
              <div class="row-sec">
                <div class="form-holder wow fadeInLeft colu">
                  <!-- <SuccessBox
                    v-if="
                      store.trans_id && store.trans_id_type == 'CHANGE PASSWORD'
                    "
                    type="ipassword"
                  /> -->
                  <Form @submit="submit">
                    <ul class="clearfix">
                      <!-- <li>
                        <label for=""
                          >Enter New Password
                          <span style="color: #cb1f1f">*</span>
                        </label>
                        <Field
                          class="form-control"
                          as="select"
                          name="account"
                          rules="required"
                          v-model="form.account_id"
                        >
                          <option value="" disabled>
                            Select Trading Account
                          </option>
                          <option
                            v-for="account of store.tradingAccounts.records"
                            :value="account.account_id"
                            :key="account.account_id"
                          >
                            {{ account.account_id }} ({{
                              account.demo_live == "1" ? "Live" : "Demo"
                            }})
                          </option>
                        </Field>
                        <ErrorMessage name="account" />
                      </li> -->
                      <li>
                        <label for=""
                          >{{$t('account.enter_new_password')}}
                          <span style="color: #cb1f1f">*</span>
                        </label>
                        <Field
                          class="form-control"
                          name="password"
                          type="password"
                          :rules="{required : true,min:6,max:10,regex :/^(?=.*[A-Z])\S{6,10}$/}"
                          v-model="form.password"
                        />
                        <ErrorMessage name="password" />
                      </li>
                      <li>
                        <label for=""
                          >{{$t('account.confirm_new_password')}}
                          <span style="color: #cb1f1f">*</span>
                        </label>
                        <Field
                          class="form-control"
                          name="confirm password"
                          type="password"
                          rules="required|confirmed:@password"
                          v-model="form.confirmPassword"
                        />
                        <ErrorMessage name="confirm password" />
                      </li>
                    </ul>
                    <div class="note">
                      <p>
                        <span style="color: #cb1f1f">*</span> {{$t('account.password_must_contain')}}
                      </p>
                    </div>
                    <div class="btn-holder t-center">
                      <button
                        type="submit"
                        class="btn btn-yellow popup-link-holder"
                      >
                      {{$t('account.change_Password')}}
                      </button>
                      <button @click="$router.back()" class="btn btn-blue">
                        {{$t('account.cancel')}}
                      </button>
                    </div>
                  </Form>
                </div>
                <div class="img-holder t-center colu wow fadeInRight">
                  <img src="assets/images/change-pass1.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
import SuccessBox from "@/components/shared/SuccessBox";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      otp: "",
      form: {
        password: "",
        confirmPassword: "",
        account_id: "",
        act_account_id: "",
        operation: "CHANGE PASSWORD",
      },
      attachment: {},
      message :'',
      msgType :''
    };
  },
  computed: {
    availableLeverages() {
      return this.static_vars.leverages.filter(
        (i) => i.value != this.store.lastSelectedAccount.leverage
      );
    },
    reasons() {
      let obj = {};
      for (let key in this.store.ticketReasons) {
        if (
          this.store.ticketReasons[key].categories &&
          this.store.ticketReasons[key].categories.length
        ) {
          obj[key] = this.store.ticketReasons[key];
        }
      }
      return obj;
    },
  },
  mounted() {
    this.form.account_id = this.store.lastSelectedAccount.account_id;
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    SuccessBox,
  },
  methods: {
    resetAndBack() {
      this.store.$patch({ trans_id: null });
      this.$router.back();
    },
    submit() {
      let formData = {
        account_id: this.form.account_id,
        act_account_id: "",
        operation: this.form.operation,
        password: this.form.password,
        type: "INVESTOR",
      };
      this.store.accountOperations(formData, true);
    },
    resend() {
      let form = {
        trans_id: this.store.trans_id,
      };
      this.store.resendOperationsLink(form, true);
    },
    verify() {
      let form = {
        type: this.form.operation,
        google_token: this.google_token,
        trans_id: `${this.store.trans_id}`,
      };
      this.store.verifyAccountOperation(form, true).then(response => {
        //modal show
        this.store.$patch({ trans_id: null });
        this.message = response
        this.msgType = 'success'
      }).catch(error => {
        this.store.$patch({ trans_id: null });
        this.message = error
        this.msgType = 'error'
      });
    },
    setImage(e) {
      this.attachment = e.target.files[0];
    },
  },
};
</script>
